// Calendrier des saisons et objets de pass (choix de Léni, 5 novembre 2026). Une saison dure un mois calendaire, ses
// limites sont en UTC (fin exclue) et affichées dans l'heure locale du joueur. La suivante remplace seulement le pass
// (progression, premium, récompenses réclamées), jamais l'inventaire, les pièces, les gemmes ni les jetons.

export interface SeasonDef {
  id: string;
  /** Nom de référence en français (traduit côté client par `seasons[id]` des catalogues). */
  name: string;
  startsAt: number;
  endsAt: number;
}

export const SEASON_DEFS: SeasonDef[] = [
  { id: 'S1', name: 'GENÈSE MÉCANIQUE', startsAt: Date.UTC(2026, 10, 1), endsAt: Date.UTC(2026, 11, 1) },
  // Saison 2 : thème Noël (choix de Léni), atelier de jouets mécaniques sous la neige.
  { id: 'S2', name: 'L’ATELIER DU PÔLE', startsAt: Date.UTC(2026, 11, 1), endsAt: Date.UTC(2027, 0, 1) },
];

/**
 * Saison 2 : mêmes pièces, gemmes et jetons que la saison 1, niveau par niveau (même barème, mêmes totaux). Seuls
 * les cosmétiques changent : aux niveaux 1, 10, 20… 100 et 105, chaque piste donne un vrai cosmétique de la
 * collection « noel » (shared/cosmetics.ts), dessiné et équipable dans l'Atelier, exclusif au pass.
 */
export const S2_COSMETIC_REWARDS: Record<number, { free: string; premium: string }> = {
  1: { free: 'dec:sapin', premium: 'mat:velours' },
  10: { free: 'trail:neige', premium: 'dec:etoilenoel' },
  20: { free: 'pat:sucredorge', premium: 'aura:boules' },
  30: { free: 'shot:clochettes', premium: 'trail:traineau' },
  40: { free: 'aura:guirlande', premium: 'pat:emballage' },
  50: { free: 'kill:cadeau', premium: 'shot:etoilefilante' },
  60: { free: 'dec:renne', premium: 'kill:nouvelan' },
  70: { free: 'death:bouledeneige', premium: 'dec:houx' },
  80: { free: 'pat:tricot', premium: 'death:bonhomme' },
  90: { free: 'trail:paillettes', premium: 'aura:etoilepolaire' },
  100: { free: 'shot:papillotes', premium: 'kill:avalanche' },
  105: { free: 'mat:paindepices', premium: 'mat:boulenoel' },
};

/**
 * Vrai si la saison a commencé. Avant son début, ses objets restent cachés dans l'Atelier : le code peut être mis en
 * ligne en avance sans dévoiler la saison (la bascule se fait seule, à la date).
 */
export function seasonStarted(id: string, now = Date.now()): boolean {
  const s = SEASON_DEFS.find((x) => x.id === id);
  return !s || s.startsAt <= now;
}

/** Niveau et piste du pass qui donnent un objet de saison, ou null. */
export function passSourceOf(itemId: string): { season: string; level: number; track: 'free' | 'premium' } | null {
  for (const [lvl, r] of Object.entries(S2_COSMETIC_REWARDS)) {
    if (r.free === itemId) return { season: 'S2', level: Number(lvl), track: 'free' };
    if (r.premium === itemId) return { season: 'S2', level: Number(lvl), track: 'premium' };
  }
  return null;
}
